export const scrollToId = (id) => {
    const selector = id.startsWith("#") ? id : `#${id}`;
    const el = document.querySelector(selector);
    if (!el) return;
    if (window.__lenis) {
        window.__lenis.scrollTo(el, { offset: -72, duration: 1.4 });
    } else {
        el.scrollIntoView({ behavior: "smooth" });
    }
};
